"use client";

import React from "react";
import { CircleCheck, Hammer, Zap, ShieldCheck, MapPin, Handshake, Check } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const challenges = [{
  icon: CircleCheck,
  title: "Licensed & Insured",
  description: "Protecting your home and assets with comprehensive coverage for property damage, personal injury, and full liability protection."
}, {
  icon: Hammer,
  title: "Quality Workmanship",
  description: "Lasting results achieved through rigorous multi-point inspection standards and the careful selection of premium, weather-resistant materials."
}, {
  icon: Zap,
  title: "Fast Response Times",
  description: "Rapid deployment to secure your home immediately after a storm, preventing secondary water damage and protecting your interior."
}, {
  icon: ShieldCheck,
  title: "Insurance Claim Assistance",
  description: "Expert guidance through every step of your claim, from initial damage assessment to final approval, ensuring a stress-free recovery."
}, {
  icon: MapPin,
  title: "Local Exterior Specialists",
  description: "Specialized expertise in Maryland's unique weather patterns, ensuring your exterior is built to withstand regional humidity and storm cycles."
}, {
  icon: Handshake,
  title: "Honest Communication",
  description: "A transparent process featuring detailed written estimates, zero hidden fees, and clear daily updates on your project's progress."
}];
export default function WhyChooseUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257361" id="why-choose-us" className="bg-background py-16 md:py-24" ref={ref}>
      <div className="page-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
          {}
          <div className={`flex flex-col justify-center lg:col-span-5 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
            <h2 className="font-default text-primary-500 mb-6 text-3xl font-bold md:text-4xl">Why Local Homeowners Trust Us</h2>
            <div className="mb-8">
              <p className="text-muted-foreground mb-4 text-lg leading-relaxed font-default">
                Here's why Eagle Exteriors wins the trust of local homeowners:
              </p>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-muted-foreground font-default">
                  <Check className="size-5 text-secondary" />
                  <span>Decades of local expertise</span>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground font-default">
                  <Check className="size-5 text-secondary" />
                  <span>Commitment to integrity and transparency</span>
                </li>
                <li className="flex items-center gap-3 text-muted-foreground font-default">
                  <Check className="size-5 text-secondary" />
                  <span>Professional results that last</span>
                </li>
              </ul>
            </div>
            
            <div className="bg-secondary text-secondary-foreground shadow-md inline-block self-start rounded-md p-6">
              <div className="mb-3 inline-flex items-center rounded-md border border-secondary-foreground/20 bg-secondary-foreground/10 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                Free Estimates
              </div>
              <h3 className="font-default mb-1 text-xl font-bold">
                Trusted Local Pros
              </h3>
              <p className="text-secondary-foreground/90 text-sm font-medium font-default">
                Serving our community with pride
              </p>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {challenges.map((challenge, i) => {
              const Icon = challenge.icon;
              return <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
                transitionDelay: `${i * 150}ms`
              }}>
                    <Card className="bg-card border-none shadow-md h-full rounded-md">
                      <CardHeader className="pb-3">
                        <div className="bg-primary/10 text-primary mb-4 flex size-12 items-center justify-center rounded-md">
                          <Icon className="size-6" aria-hidden="true" />
                        </div>
                        <CardTitle className="font-default text-primary-500 text-lg font-bold">
                          {challenge.title}
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <p className="text-muted-foreground text-sm leading-relaxed font-default">
                          {challenge.description}
                        </p>
                      </CardContent>
                    </Card>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}